<template>
  <v-container >
    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('input.serch')"
          single-line
          outlined
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <!-- <v-col cols="2">
        <v-btn
          text
          @click="downloadExcel()"
          outlined
          color="green"
          target="blank"
          >Excel<v-icon class="ml-2">mdi-download</v-icon></v-btn
        >
      </v-col> -->
    </v-row>

    <v-data-table
      :search="search"
      v-model="selected"
      :headers="headers"
      :items="data"
       class="elevation-0"
      @update:items-per-page="getItemPerPage"
      :footer-props="{
        showFirstLastPage: false,
        'items-per-page-options': [10, 20, 30, 40, 50],
        'items-per-page-text': 'Page',
      }"
    >
      <template v-slot:[`item.created_at`]="{ item }">
        {{ $subStringDate(item.created_at) }}
      </template>
      <template v-slot:[`item.did`]="{ item }">
        <v-btn v-if="item.did == null" small @click="updateItem(item)">
          {{ $t("btn.update") }}
          <v-icon color="primary"> mdi-pencil </v-icon>
        </v-btn>
        <v-chip v-else dark> {{ getEmployee(item.did)?.name }} </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn icon small @click="updateItem(item)">
          <v-icon color="grey"> mdi-pencil </v-icon>
        </v-btn>
        <v-btn icon small @click="deleteItem(item)">
          <v-icon color="red"> mdi-minus-circle </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <Popup
      :dialog="updateDialog"
      :update="true"
      :data="updateData"
      @close-dialog="updateClose"
    />
    <ConfirmDialog
      ref="ConfirmDialogDeleteingProduct"
      :title="$t('dialog.delete.title')"
      :text="$t('dialog.delete.text')"
      :butttonText="$t('dialog.delete.btn')"
      icon="mdi-delete"
      color="error"
      @confirm-dialog="excuteConfirmDeleteingProduct"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Popup from "./Popup.vue";
import ConfirmDialog from "../../components/ConfirmDialog.vue";

// import ExportExcel from "@/helper/ExportExcel.js";
export default {
  name: "Table-vehicle",
  props: {
    data: { type: Array, default: () => [] },
  },

  data() {
    return {
      selected: [],
      updateDialog: false,
      updateData: {},
      search: "",
      headers: [
        {
          text: "#id",
          align: "center",
          sortable: true,
          value: "id",
        },
        // { text: this.$t("vehicle.table.type"), value: "type" },
        { text: this.$t("vehicle.table.employee"), value: "did" },
        { text: this.$t("vehicle.table.brand"), value: "brand" },
        { text: this.$t("vehicle.table.model"), value: "model" },
        { text: this.$t("vehicle.table.carId"), value: "carId" },
        { text: this.$t("vehicle.table.engineType"), value: "engineType" },

        { text: this.$t("vehicle.table.created_at"), value: "created_at" },
        {
          text: this.$t("vehicle.table.edite"),
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    userMe() {
      return this.$store.getters["users/userMe"];
    },
    ...mapGetters("employees", ["employees"]),
  },
  created() {
    this.param = this.$router.history.current.params.id;
  },
  components: {
    Popup,
    ConfirmDialog,
  },
  methods: {
    ...mapActions("vehicleStore", ["deleteOne", "list"]),
    getEmployee(id) {
      return this.employees.filter((em) => {
        return em.id == id;
      })[0];
    },
    excuteConfirmDeleteingProduct(val) {
      let payload = {
        id: val.id,
      };
      this.deleteOne(payload).then(() => {
        this.list({});
      });
    },

    deleteItem(item) {
      this.$refs.ConfirmDialogDeleteingProduct.openDialog(item);
    },
    updateItem(item) {
      this.updateData = item;
      this.updateDialog = true;
    },
    updateClose(val) {
      this.updateDialog = false;
    },
    getItemPerPage(val) {
      console.log(val);
    },
    // downloadExcel() {
    //   const excel = new ExportExcel();
    //   excel.downloadProductsXLSX(this.data, this.userMe);
    // },
  },
};
</script>
